module.exports = __webpack_public_path__ + "WB.svg?a80dca97da51b8a1934e619850ef210b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/WB.svg
// module id = 75
// module chunks = 0